var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticStyle:{"min-width":"max-content"},attrs:{"color":_vm.chipsColor(_vm.type).bg,"text-color":_vm.chipsColor(_vm.type).color}},[_vm._v(" "+_vm._s(_vm.type)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }